import { render, staticRenderFns } from "./addEditorManage.vue?vue&type=template&id=a3882f36&scoped=true"
import script from "./addEditorManage.vue?vue&type=script&lang=js"
export * from "./addEditorManage.vue?vue&type=script&lang=js"
import style0 from "./addEditorManage.vue?vue&type=style&index=0&id=a3882f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3882f36",
  null
  
)

export default component.exports